var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#b0c8ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#004cff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 286,
    x2: 286,
    y1: 481,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#adc5ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#eaf6ff",
    offset: 0.503
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#91aaff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M323.5 30h-240c-24.814 0-45 20.186-45 45v392c0 24.814 20.186 45 45 45h240c24.814 0 45-20.186 45-45V75c0-24.814-20.186-45-45-45zm135 31h-30c-8.401 0-15 6.599-15 15v240l30 30 30-30V76c0-8.401-6.599-15-15-15z",
    "data-original": "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M278.5 15c0-8.291-6.709-15-15-15h-120c-8.291 0-15 6.709-15 15 0 24.814 20.186 45 45 45h60c24.814 0 45-20.186 45-45zM147.895 155.395 128.5 174.789l-4.395-4.395c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211l15 15c5.859 5.859 15.352 5.859 21.211 0l30-30c5.859-5.859 5.859-15.352 0-21.211s-15.351-5.859-21.21.001zm0 90L128.5 264.789l-4.395-4.395c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211l15 15c5.859 5.859 15.352 5.859 21.211 0l30-30c5.859-5.859 5.859-15.352 0-21.211s-15.351-5.859-21.21.001zm0 90L128.5 354.789l-4.395-4.395c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211l15 15c5.859 5.859 15.352 5.859 21.211 0l30-30c5.859-5.859 5.859-15.352 0-21.211s-15.351-5.859-21.21.001zM293.5 181h-90c-8.291 0-15 6.709-15 15s6.709 15 15 15h90c8.291 0 15-6.709 15-15s-6.709-15-15-15zm0 90h-90c-8.291 0-15 6.709-15 15s6.709 15 15 15h90c8.291 0 15-6.709 15-15s-6.709-15-15-15zm0 90h-90c-8.291 0-15 6.709-15 15s6.709 15 15 15h90c8.291 0 15-6.709 15-15s-6.709-15-15-15zm120-45v77.701c0 18.512 5.413 36.762 15 52.687V466c0 8.291 6.709 15 15 15s15-6.709 15-15v-19.611c9.587-15.925 15-34.175 15-52.689V316z",
    "data-original": "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskList);
export default __webpack_public_path__ + "static/media/task-list.1ccd205fb88cc589dd307f15fdab8678.svg";
export { ForwardRef as ReactComponent };